import stylesSpinner from 'styles/components/Spinner.module.css';

const Spinner = () => <div className={stylesSpinner.Spinner}></div>;

export default Spinner;